/**
 * Feature cards (sections/feature-cards.liquid): starts loading every
 * card's image when the section is within about one and a half screens.
 * The browser's own lazy loading waits until images are nearly on screen,
 * and for the cards off to the side in the mobile row, until each is swiped
 * into view.
 */
class FeatureCards extends HTMLElement {
  connectedCallback() {
    this.nearObserver = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      this.nearObserver.disconnect();
      this.querySelectorAll('img[loading="lazy"]').forEach((img) => {
        img.loading = 'eager';
      });
    }, { rootMargin: '150% 0px' });
    this.nearObserver.observe(this);
  }

  disconnectedCallback() {
    this.nearObserver.disconnect();
  }
}

if (!customElements.get('feature-cards')) {
  customElements.define('feature-cards', FeatureCards);
}
